import { render } from "./CV.vue?vue&type=template&id=5a751cb7&ts=true"
import script from "./CV.vue?vue&type=script&lang=ts"
export * from "./CV.vue?vue&type=script&lang=ts"

import "./CV.vue?vue&type=style&index=0&id=5a751cb7&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__